import { axios } from "./index";

class CensusApi {
  static getWeeklyCensusData = (weekOffset) => {
    return axios.get(`${base}/weekly`, { params: { weekOffset } });
  };
}

let base = "census";

export default CensusApi;
